<template>
  <!-- 中信项目-兑换码页面定制 同步 T1006282 兑换链接 -->
  <div id="listbox">
    <img
      src="@/assets/img/citicSync/ypost2.png"
      v-show="![1].includes(+$route.query.type)"
    />
    <!-- <h5>如有疑问，请通过咚咚联系下单店铺的在线客服。</h5> -->
    <ul class="lists">
      <li v-for="item in lists" :key="item.id">
        <div class="header">
          兑换码:
          <div class="omit">{{ item.redeCodeNo }}</div>
        </div>
        <!-- gcShape 0：卡号卡密 1：卡密 2：卡号短链 3：卡号短链验证码 -->
        <div class="info">
          <div class="title">兑换时间</div>
          <div class="omit">
            {{ common.formatDate(item.excTime, '{yyyy}/{mm}/{dd}') || '-' }}
          </div>
        </div>
        <!-- <div class="info" v-show="![1].includes(+$route.query.type)">
          <div class="title">店铺订单号</div>
          <div class="omit">
            {{ item.outOrdNo || '-' }}
          </div>
        </div> -->
        <div class="info">
          <div class="title">商品名称</div>
          <div style="padding: 0 2vw;">
            {{ item.gcName || '-' }}
          </div>
        </div>
        <!-- 卡号卡密 -->
        <div v-show="[0].includes(item.gcShape)">
          <div class="info">
            <div class="title">卡&nbsp;&nbsp;&nbsp;号</div>
            <div class="omit">{{ item.cardNo }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info">
            <div class="title">密&nbsp;&nbsp;&nbsp;码</div>
            <div class="omit">{{ item.cardPwd }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </div>
        <!-- 卡密 -->
        <div class="info" v-show="[1].includes(item.gcShape)">
          <div class="title">卡&nbsp;&nbsp;&nbsp;密</div>
          <div class="omit">{{ item.cardPwd }}</div>
          <div class="btn" @click="copyData(item.cardPwd, item)">
            复制
          </div>
        </div>
        <!-- 卡号短链 -->
        <div class="info" v-show="[2].includes(item.gcShape)">
          <div class="title">短&nbsp;&nbsp;&nbsp;链</div>
          <a
            class="omit blue"
            v-if="item.shortUrl && item.shortUrl.startsWith('http')"
            :href="item.shortUrl"
          >
            {{ item.shortUrl }}
          </a>
          <div class="omit" v-else>{{ item.shortUrl }}</div>
          <div
            class="btn"
            v-clipboard:copy="item.shortUrl"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >
            复制
          </div>
        </div>
        <!-- 卡号短链验证码 -->
        <div v-show="[3].includes(item.gcShape)">
          <div class="info">
            <div class="title">卡&nbsp;&nbsp;&nbsp;号</div>
            <div class="omit">{{ item.cardNo }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info">
            <div class="title">短&nbsp;&nbsp;&nbsp;链</div>
            <a
              class="omit blue"
              v-if="item.shortUrl && item.shortUrl.startsWith('http')"
              :href="item.shortUrl"
            >
              {{ item.shortUrl }}
            </a>
            <div class="omit" v-else>{{ item.shortUrl }}</div>

            <div
              class="btn"
              v-clipboard:copy="item.shortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info">
            <div class="title">密&nbsp;&nbsp;&nbsp;码</div>
            <div class="omit">{{ item.verifyCode }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.verifyCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </div>

        <div class="info">
          <div class="title">有效期</div>
          <div class="omit">
            {{ common.formatDate(item.virtualEndTime, '{yyyy}/{mm}/{dd}') }}
          </div>
        </div>
        <!-- 跳转微信小程序&微信内部才支持 -->
        <wxLaunchWeapp
          v-if="shouldShowWeapp(item.gcName)"
          :username="getAppId(item.gcName)"
          :path="getPath(item.gcName)"
        />
        <!-- 跳转微信小程序 外部浏览器，等方式拉起小程序 -->
        <div
          v-if="shouldShowWeappOutside(item.gcName)"
          class="outsideWeChat"
          @click="outsideGoWeapp(item.gcName)"
        >
          点击跳转小程序去使用
        </div>
      </li>
    </ul>
    <div class="describe" v-if="describe">
      <div class="title">商品使用说明</div>
      <div class="text" v-html="describe"></div>
    </div>
  </div>
</template>

<script>
import { citicListRedeem, citicGetWxSign } from '@/api/citicSync.js'
import wxLaunchWeapp from './component/wxLaunchWeapp.vue'
export default {
  components: { wxLaunchWeapp },
  data() {
    return {
      lists: [],
      describe: undefined,
      appId: 'gh_f1f7cebb53a3'
    }
  },
  async mounted() {
    await this.initApi()
    await this.loadData()
  },
  methods: {
    async loadData() {
      const { code, data, message } = await citicListRedeem(this.$route.query)
      if (code === 0) {
        this.lists = data?.outStorageDetailsVOList || []
        this.describe = data?.describe
      } else {
        this.$toast.fail({
          message: message
        })
      }
    },
    copyData(copyVal, item) {
      this.$copyText(copyVal).then(
        e => {
          this.copySuccess(item)
        },
        e => {
          this.copyError()
        }
      )
    },
    copySuccess(item) {
      const gcName = item?.gcName
      const type = item?.gcShape
      // gcShape 0：卡号卡密 1：卡密 2：卡号短链 3：卡号短链验证码
      // 微信外且麦当劳商品且卡密类型则弹框提示去微信
      if (
        (gcName?.includes('麦当劳代金券（新版）') ||
          gcName?.includes('麦当劳麦金卡') ||
          gcName?.includes('麦当劳代金券')) &&
        !this.isWechat() &&
        [1].includes(type)
      ) {
        this.$toast({
          message:
            '复制成功，“微信搜索麦当劳小程序”点击“我的-选择兑换券-输入兑换码”',
          duration: 5000
        })
      } else {
        this.$toast({
          message: '复制成功'
        })
      }
    },
    copyError() {
      this.$toast({
        message: '复制失败'
      })
    },
    // 获取appId
    getAppId(gcName) {
      if (
        gcName.includes('麦当劳代金券（新版）') ||
        gcName.includes('麦当劳麦金卡')
      ) {
        return 'gh_f1f7cebb53a3'
      } else if (gcName.includes('云闪付') || gcName.includes('微信')) {
        return 'gh_af43ccbd7906'
      }
    },
    // 获取小程序跳转路径
    getPath(gcName) {
      if (
        gcName.includes('麦当劳代金券（新版）') ||
        gcName.includes('麦当劳麦金卡')
      ) {
        return ''
      } else if (gcName.includes('云闪付')) {
        return `/pages/container/index?businessUrl=${encodeURIComponent(
          'https://mapa.quancangyun.cn/ydsh-pq-h5-redeem-code/#/exchangeCodeYsf'
        )}`
      } else if (gcName.includes('微信')) {
        return `/pages/container/index?businessUrl=${encodeURIComponent(
          'https://mapa.quancangyun.cn/ydsh-pq-h5-redeem-code/#/exchangeCodeNew'
        )}`
      }
    },
    // 判断是否显示小程序按钮 & 微信内部环境
    shouldShowWeapp(gcName) {
      const keywords = [
        '微信',
        '云闪付',
        '麦当劳代金券（新版）',
        '麦当劳麦金卡'
      ]
      return (
        this.isWechat() && keywords.some(keyword => gcName.includes(keyword))
      )
    },
    // 判断是否显示小程序按钮 & 非微信内部环境 & !麦当劳因为麦当劳没有path url scheme方式拉不起来
    shouldShowWeappOutside(gcName) {
      const keywords = ['微信', '云闪付']
      return (
        !this.isWechat() && keywords.some(keyword => gcName.includes(keyword))
      )
    },
    // URL Scheme明文方式拉起微信小程序，可在外部浏览器也可在微信环境内拉起小程序，但是有次数限制，而且必须要知道appid,跟path「小程序管理后台 -> 设置 -> 隐私与安全 -> 明文 scheme 拉起此小程序]，开发文档https://developers.weixin.qq.com/community/develop/doc/00024e32cbc36055c0c0a34b066401
    outsideGoWeapp(gcName) {
      let appid, weappUrl
      if (gcName.includes('云闪付')) {
        appid = 'wx34cd5e285f2a0813'
        // businessUrl =
        //   'https://mapa.quancangyun.cn/ydsh-pq-h5-redeem-code/#/exchangeCodeYsf'
        weappUrl = 'pages/exchangeCodeYsfContainer/index'
      } else if (gcName.includes('微信')) {
        appid = 'wx34cd5e285f2a0813'
        // businessUrl =
        //   'https://mapa.quancangyun.cn/ydsh-pq-h5-redeem-code/#/exchangeCodeNew'
        weappUrl = 'pages/exchangeCodeNewContainer/index'
      } else {
        // 如果不支持的类型，给出提示
        this.$toast('暂不支持该商品类型的小程序跳转')
        return
      }
      // 这种方式跳转到臻券管是跳到首页，然后首页帮忙跳到微信、云闪付，目前安卓跳不到云闪付ios可以所以改成直接跳转方式
      // const path = `weixin://dl/business/?appid=${appid}&path=pages/container/index&query=businessUrl=${encodeURIComponent(
      //   businessUrl
      // )}`
      const path = `weixin://dl/business/?appid=${appid}&path=${weappUrl}`
      window.location.href = path
    },
    // 判断当前环境是否是微信环境 true为微信环境
    isWechat() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger')
    },
    async initApi() {
      // 如果不是微信环境，直接返回，不执行微信SDK初始化
      if (!this.isWechat()) {
        console.log('非微信环境，跳过微信SDK初始化')
        return Promise.resolve()
      }
      const currentUrl = window.location.href.split('#')[0]
      const { data } = await citicGetWxSign({
        signUrl: encodeURIComponent(currentUrl)
      })
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        wx.config({
          debug: false,
          appId: data.appid,
          timestamp: data.timestamp,
          nonceStr: data.noncestr,
          signature: data.signature, // 任意非空字符串
          jsApiList: ['hideMenuItems', 'hideAllNonBaseMenuItem'],
          openTagList: ['wx-open-launch-weapp']
        })
        // eslint-disable-next-line no-undef
        wx.ready(() => {
          resolve()
        })
        // eslint-disable-next-line no-undef
        wx.error(err => {
          console.log(111, err)
          alert('微信初始化失败')
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../citicSync/ycitiSync.less';
.blue {
  color: #fff;
  text-decoration: underline;
  padding: 0 !important;
  margin: 0 2.47vw;
}
.outsideWeChat {
  color: #c69528;
  font-size: 28px;
  text-align: center;
  margin: 40px auto 0px;
  padding: 40px 0px 0px;
  border-top: 1px dashed rgb(255, 255, 255);
  font-weight: bold;
  border-bottom: none;
  border-left: none;
  border-right: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  width: 93%;
}
</style>
